<template>
  <NdsDropdown
    :max-height="600"
    :placement="NdsPopoverPlacement.BOTTOM_END"
  >
    <template #trigger>
      <NdsButton
        :color="NdsButtonColor.TRANSPARENT"
        :size="NdsButtonSize.S"
      >
        <span v-if="store.getters.customer === store.getters.none_label">
          <AppIcon
            class="customerSelectorDropdown__icon"
            color="primary"
            custom_icon="server"
            fa_type="far"
            icon_size="1rem"
          />
          <span>{{ store.getters.instance }}</span>
        </span>
        <span v-else>
          {{ store.getters.customer }}
        </span>
      </NdsButton>
    </template>

    <template #dropdownContent>
      <NdsMenuItem
        v-for="customer in customers"
        :key="customer.id"
        :is-checkable="false"
        @input="setCustomer(customer.id)"
      >
        <template #label>
          <div class="customerSelectorDropdown__item">
            <template v-if="customer.name !== store.getters.none_label">
              <AppIcon
                class="customerSelectorDropdown__icon"
                color="primary"
                custom_icon="user-circle"
                fa_type="far"
                icon_size="1rem"
              />
              <span>{{ customer.name }}</span>
            </template>
            <template v-else>
              <AppIcon
                class="customerSelectorDropdown__icon"
                color="primary"
                custom_icon="server"
                fa_type="far"
                icon_size="1rem"
              />
              <span>{{ store.getters.instance }}</span>
            </template>
          </div>
        </template>
      </NdsMenuItem>
    </template>
  </NdsDropdown>
</template>

<script setup lang="ts">
import Vue, { computed } from 'vue'
import { useRouter } from 'vue-router/composables'
import AppIcon from '@/components/ui/AppIcon.vue'
import NdsButton from '@/components/NewDesignSystem/NdsButton/NdsButton.vue'
import NdsDropdown from '@/components/NewDesignSystem/NdsDropdown/NdsDropdown.vue'
import NdsMenuItem from '@/components/NewDesignSystem/NdsMenuItem/NdsMenuItem.vue'
import { NdsButtonColor, NdsButtonSize } from '@/components/NewDesignSystem/NdsButton/NdsButton.interfaces'
import { NdsPopoverPlacement } from '@/components/NewDesignSystem/NdsPopover/NdsPopover.interfaces'
import { useStore } from '@/store'
import type { Customer } from '@/components/layout/main-header/connected/CustomerSelectorDropdown.interfaces'
import { sortWithNegativeIdFirst } from '@/components/layout/main-header/connected/CustomerSelectorDropdown.helpers'

const _ = Vue.prototype._
const $toast = Vue.prototype.$toast

const store = useStore()
const router = useRouter()

const customers = computed<Customer[]>(() => {
  const allCustomers: Customer[] = store.getters.customers
  const filtered = store.getters.impersonate_contributor
    ? allCustomers.filter((e) => e.name !== store.getters.customer && e.id > 0)
    : allCustomers.filter((e) => e.name !== store.getters.customer)

  return filtered.slice().sort(sortWithNegativeIdFirst).slice(0, 12)
})

const setCustomer = (id: number) => {
  store
    .dispatch('setCustomer', id)
    .then(() => {
      router.push({ name: store.getters.isPiloteOrAuditor ? 'ghome' : 'lhome' }).finally(() => {
        window.location.reload()
      })
    })
    .catch((err: unknown) => {
      console.error(err)
      $toast.alert(_('Customer context update failed'))
    })
}
</script>

<style lang="scss" scoped>
.customerSelectorDropdown {
  &__icon {
    pointer-events: none;
  }

  &__item {
    display: flex;
    align-items: center;
    gap: 8px;
  }
}
</style>
